const GROUPS = ['delivered', 'free', 'paid'];

const escapeCell = value => {
  const text = String(value ?? '');
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// One line per day, group (delivered/free/paid) and key, the same numbers shown on screen.
// Paid lines also carry the cost of that day and category.
export const buildInsightsCsv = (daily, { headers, groupLabel, keyLabel }) => {
  const lines = daily.flatMap(day =>
    GROUPS.flatMap(group =>
      Object.entries(day[group]).map(([key, volume]) => [
        day.date,
        groupLabel(group),
        keyLabel(group, key),
        volume,
        group === 'paid' ? (day.cost_by_key?.[key] ?? '') : '',
      ])
    )
  );
  return [headers, ...lines]
    .map(line => line.map(escapeCell).join(','))
    .join('\n');
};
